/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Table, Empty } from 'antd';
import AccountingDetailsContext from '../../../contexts/accounting-context/AccountingDetailsContext';
import UserContext from '../../../contexts/user-context/UserProvider';
import TableColumns from './TableColumns';
import JournalsContext from '../../../contexts/accounting-context/JournalsContext';
import SummaryContext from '../../../contexts/accounting-context/SummaryContext';
import AccountStatementContext from '../../../contexts/accounting-context/AccountStatementContext';
import { useTranslation } from 'react-i18next';

const AccountStatementDetailsTable = ({ type }) => {
  const { user } = useContext(UserContext);
  const {
    fetchedAccountStatementDetails,
    fetchCount,
    setIsLoading,
    setFetchCount,
    setModalOpened,
    setSelectedSummary,
    isLoading,
    setModalOpenedUpdate
  } = useContext(AccountStatementContext);
  const { t } = useTranslation();

  // map all data to dataSource
  const [tableDataSource, setTableDataSource] = useState([]);
  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id,
      index: index + 1,
      name: obj?.name ? obj.name : '',
      description: obj?.name ? obj.name : '',
      title: obj?.title ? obj.title : '',
      the_amount: obj?.balance
        ? obj.balance
        : obj.initial_balance
        ? obj.initial_balance
        : ''
    }));
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setTableDataSource(
        fetchedAccountStatementDetails && fetchedAccountStatementDetails
      );
    }
    return () => {
      isMounted = false;
    };
  }, [fetchCount, fetchedAccountStatementDetails]);

  return (
    <>
      <h2>بيان معاملات الحساب</h2>
      <Table
        locale={{
          emptyText: (
            <Empty description={false}>{t('Messages.noDataAvailable')}</Empty>
          )
        }}
        pagination={{ defaultPageSize: 10, hideOnSinglePage: true }}
        className="antd-custom-table"
        dataSource={tableDataSource}
        columns={TableColumns(
          fetchedAccountStatementDetails,
          setModalOpened,
          setModalOpenedUpdate,
          setFetchCount,
          setSelectedSummary,
          setIsLoading,
          user?.token,
          type
        )}
        loading={isLoading}
        // scroll={{ x: 400 }}
        footer={false}
      />
    </>
  );
};

export default AccountStatementDetailsTable;
